<template>
  <div>
    <navHeader />
    <div class="det-body">
      <div class="container">
        <div class="tender-info-top">
          <div class="basic-info-title">
            <h1 class="order-title">{{ info.Title }}<span>自由平台</span></h1>
            <p class="address-text">
              {{ info.ProvinceName }} · {{ info.CityName }}
            </p>
          </div>
          <ul class="basic-info-label">
            <li>
              <label for="">现场联系人：</label>
              <p>{{ info.JobLinkMan }}</p>
            </li>
            <li>
              <label for="">单<span style="opacity: 0;">站位</span>号：</label>
              <p>{{ info.JobNo }}</p>
            </li>
            <li>
              <label for="">联系电话：</label>
              <p>{{ info.JobHandSet }}</p>
            </li>
            <li>
              <label for="">上门时间：</label>
              <p>{{ info.ExecStartDate }} 至 {{ info.ExecEndDate }}</p>
            </li>
            <li>
              <label for="">预计服务天数</label>
              <p>{{ info.ServiceDayCount }}</p>
            </li>
            <li>
              <label for="">预算总价：</label>
              <p>￥{{ info.MinPrice }}-{{ info.MaxPrice }}</p>
            </li>
          </ul>
        </div>
        <div class="tender-set-content">
          <h3 class="h3-title">服务方案</h3>
          <div>
            <div>
              <div class="subtitle">
                <h2>出发地址<i>*</i></h2>
                <button @click="clickReplaceAddressFun()">更换</button>
              </div>
              <p
                class="address-text"
                :Lat="addressInfo.Lat"
                :Lng="addressInfo.Lng"
              >
                {{ addressInfo.StartingAddress }}
              </p>
              <div class="km" v-show="addressInfo.StartingAddress">
                <span>距离服务地点{{ addressInfo.JobDistance }}Km</span>
              </div>
            </div>
            <div>
              <div class="gery-bg">背景</div>
              <div>
                <div class="subtitle">
                  <h2>服务报价<i>*</i></h2>
                  <div class="bid-cost-switch">
                    <div>
                      <template v-if="LoginType == 2">
                        <span
                          :class="{ 'on-tab': isTax }"
                          @click="clickSwitchTaxFun(true)"
                          >含税</span
                        >
                        &nbsp;/&nbsp;
                        <span
                          :class="{ 'on-tab': !isTax }"
                          @click="clickSwitchTaxFun(false)"
                          >不含税</span
                        >
                      </template>
                      <template v-else>
                        <span
                          :class="{ 'on-tab': !isTax }"
                          @click="clickSwitchTaxFun(false)"
                          >含税</span
                        >
                        &nbsp;/&nbsp;
                        <span
                          :class="{ 'on-tab': isTax }"
                          @click="clickSwitchTaxFun(true)"
                          >不含税</span
                        >
                      </template>
                    </div>
                  </div>
                </div>
                <div class="bid-cost-detail">
                  <ul :class="[!isTax ? 'disabled' : '']">
                    <li>
                      <label for="">预计服务天数：<i>*</i></label>
                      <input
                        type="text"
                        placeholder="请输入预计服务天数（天）"
                        :disabled="!isTax"
                        v-model.number="projectJobPriceDetail.WorkLogDayCount"
                      />
                    </li>
                    <template v-if="LoginType == 2">
                      <li>
                        <label for="">服务报价：<i>*</i></label>
                        <input
                          type="text"
                          placeholder="请输入服务报价（元）"
                          v-show="isTax"
                          v-model.number="
                            projectJobPriceDetail.WorkLogAmountTax
                          "
                        />
                        <input
                          type="text"
                          placeholder="请输入服务报价（元）"
                          v-show="!isTax"
                          :disabled="!isTax"
                          v-model="WorkLogAmountNoTaxRate"
                        />
                      </li>
                      <li>
                        <label for="">交通费用：</label>
                        <input
                          type="text"
                          placeholder="请输入交通费用（元）"
                          v-show="isTax"
                          v-model.number="
                            projectJobPriceDetail.TrafficAmountTax
                          "
                        />
                        <input
                          type="text"
                          placeholder="请输入交通费用（元）"
                          v-show="!isTax"
                          :disabled="!isTax"
                          v-model="TrafficAmountNoTaxRate"
                        />
                      </li>
                      <li>
                        <label for="">住宿费用：</label>
                        <input
                          type="text"
                          placeholder="请输入住宿费用（元）"
                          v-show="isTax"
                          v-model.number="
                            projectJobPriceDetail.HousingAmountTax
                          "
                        />
                        <input
                          type="text"
                          placeholder="请输入住宿费用（元）"
                          v-show="!isTax"
                          :disabled="!isTax"
                          v-model="HousingAmountNoTaxRate"
                        />
                      </li>
                      <li>
                        <label for="">总费用：</label>
                        <p class="sum">
                          ￥{{
                            isTax ? TotalAmountTaxRate : TotalAmountNoTaxRate
                          }}
                        </p>
                      </li>
                    </template>
                    <template v-else>
                      <li>
                        <label for="">服务报价：<i>*</i></label>
                        <input
                          type="text"
                          placeholder="请输入服务报价（元）"
                          v-show="isTax"
                          v-model.number="projectJobPriceDetail.WorkLogAmount"
                        />
                        <input
                          type="text"
                          placeholder="请输入服务报价（元）"
                          v-show="!isTax"
                          :disabled="!isTax"
                          v-model="WorkLogAmountYesTaxRate"
                        />
                      </li>
                      <li>
                        <label for="">交通费用：</label>
                        <input
                          type="text"
                          placeholder="请输入交通费用（元）"
                          v-show="isTax"
                          v-model.number="projectJobPriceDetail.TrafficAmount"
                        />
                        <input
                          type="text"
                          placeholder="请输入交通费用（元）"
                          v-show="!isTax"
                          :disabled="!isTax"
                          v-model="TrafficAmountYesTaxRate"
                        />
                      </li>
                      <li>
                        <label for="">住宿费用：</label>
                        <input
                          type="text"
                          placeholder="请输入住宿费用（元）"
                          v-show="isTax"
                          v-model.number="projectJobPriceDetail.HousingAmount"
                        />
                        <input
                          type="text"
                          placeholder="请输入住宿费用（元）"
                          v-show="!isTax"
                          :disabled="!isTax"
                          v-model="HousingAmountYesTaxRate"
                        />
                      </li>
                      <li>
                        <label for="">总费用：</label>
                        <p class="sum">
                          ￥{{
                            isTax ? TotalAmountTaxs : TotalAmountYesTaxRate
                          }}
                        </p>
                      </li>
                    </template>
                  </ul>
                </div>
                <p class="tips">
                  注：企业用户需向工业速派开具增值税专用发票。
                  如有疑问，请联系客服
                </p>
              </div>
              <div class="gery-bg">背景</div>
            </div>
            <div>
              <div class="subtitle">
                <h2>解决方案<i>*</i></h2>
              </div>
              <div>
                <textarea
                  class="textarea"
                  maxlength="100"
                  v-model="projectJobPriceDetail.content"
                  placeholder="请描述您的服务方案"
                ></textarea>
              </div>
            </div>
            <div>
              <div class="subtitle">
                <h2>补充文档</h2>
              </div>
              <div class="itmes-content">
                <template v-if="DocFileList.length != 0">
                  <template v-for="(item, i) in DocFileList">
                    <span :key="i">
                      <template>
                        <i
                          class="delete-this-dom"
                          @click="removeEngineerDoc(i)"
                        >
                          <svg
                            t="1572586652683"
                            class="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            p-id="3106"
                            width="12"
                            height="12"
                          >
                            <path
                              d="M882.048 209.216L209.28 882.048c-18.624 18.56-48.768 18.56-67.328 0s-18.56-48.704 0-67.328L814.72 141.952c18.624-18.56 48.768-18.56 67.328 0 18.56 18.56 18.56 48.704 0 67.264z"
                              fill="#f75959"
                              p-id="3107"
                            ></path>
                            <path
                              d="M882.048 882.048c-18.56 18.56-48.704 18.56-67.328 0L141.952 209.216c-18.56-18.624-18.56-48.704 0-67.264 18.56-18.56 48.704-18.56 67.328 0L882.048 814.72c18.56 18.624 18.56 48.768 0 67.328z"
                              fill="#f75959"
                              p-id="3108"
                            ></path>
                          </svg>
                        </i>
                      </template>
                      <template
                        v-if="
                          item.IconUrl.indexOf('.jpg') !== -1 ||
                            item.IconUrl.indexOf('.png') !== -1 ||
                            item.IconUrl.indexOf('.jpeg') !== -1 ||
                            item.IconUrl.indexOf('.gif') !== -1
                        "
                      >
                        <img
                          :src="item.IconUrl"
                          :alt="item.FileName"
                          preview="4"
                          :preview-text="item.UserName"
                        />
                      </template>
                      <template v-else-if="item.IconUrl.indexOf('.doc') !== -1">
                        <a :href="item.IconUrl">
                          <img
                            src="static/file/icon_doc.jpg"
                            :alt="item.FileName"
                          />
                        </a>
                      </template>
                      <template
                        v-else-if="item.IconUrl.indexOf('.docx') !== -1"
                      >
                        <a :href="item.IconUrl">
                          <img
                            src="static/file/icon_docx.jpg"
                            :alt="item.FileName"
                          />
                        </a>
                      </template>
                      <template
                        v-else-if="item.IconUrl.indexOf('.excel') !== -1"
                      >
                        <a :href="item.IconUrl">
                          <img
                            src="static/file/icon_excel.jpg"
                            :alt="item.FileName"
                          />
                        </a>
                      </template>
                      <template v-else-if="item.IconUrl.indexOf('.pdf') !== -1">
                        <a :href="item.IconUrl">
                          <img
                            src="static/file/icon_pdf.jpg"
                            :alt="item.FileName"
                          />
                        </a>
                      </template>
                      <template v-else-if="item.IconUrl.indexOf('.rar') !== -1">
                        <a :href="item.IconUrl">
                          <img
                            src="static/file/icon_rar.jpg"
                            :alt="item.FileName"
                          />
                        </a>
                      </template>
                      <template
                        v-else-if="item.IconUrl.indexOf('.word') !== -1"
                      >
                        <a :href="item.IconUrl">
                          <img
                            src="static/file/icon_word.jpg"
                            :alt="item.FileName"
                          />
                        </a>
                      </template>
                      <template v-else-if="item.IconUrl.indexOf('.xls') !== -1">
                        <a :href="item.IconUrl">
                          <img
                            src="static/file/icon_xls.jpg"
                            :alt="item.FileName"
                          />
                        </a>
                      </template>
                      <template
                        v-else-if="item.IconUrl.indexOf('.xlsx') !== -1"
                      >
                        <a :href="item.IconUrl">
                          <img
                            src="static/file/icon_xlsx.jpg"
                            :alt="item.FileName"
                          />
                        </a>
                      </template>
                      <template v-else-if="item.IconUrl.indexOf('.zip') !== -1">
                        <a :href="item.IconUrl">
                          <img
                            src="static/file/icon_zip.jpg"
                            :alt="item.FileName"
                          />
                        </a>
                      </template>
                    </span>
                  </template>
                </template>
                <template v-if="DocFileList.length < 6">
                  <div class="upload-div">
                    <el-upload
                      class="btn-upload"
                      :action="UploadImg"
                      :on-success="supplementDocument"
                      :show-file-list="false"
                    >
                      <i class="icon-file el-icon-plus"></i>
                    </el-upload>
                  </div>
                </template>
              </div>
              <p class="tips" style="text-align: left;">
                注：最多上传6个文件，单个文件不超过60M，格式为：jpg/gif/png/rar/doc/pdf/ppt
              </p>
            </div>
          </div>
          <div
            v-if="addressInfo.JobDistance > 200"
            style="font-size: 14px;color: #333333;"
          >
            此工单可能离您距离过远，请您谨慎投标
          </div>
          <div style="text-align: center;">
            <button
              class="submit-tender"
              @click="SubmitTenderAndSave"
              :disabled="submitDisabled"
            >
              {{ label }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <my-dialog
      :show="goAdderssShow"
      title="出发地址"
      @close="goAdderssShow = false"
    >
      <div class="address-list-div">
        <ul class="address-box-ul">
          <li
            class="address-items"
            v-for="(item, index) in addressList"
            :key="index"
          >
            <div @click="onRadioChange(item)">
              <input
                type="radio"
                :id="'radio_' + index"
                name="addressInfo"
                :checked="item.Id == addressValueId"
                :value="item"
                class="radio"
              />
              <label :for="'radio_' + index">
                <div class="address-info-content">
                  <h3>
                    地址{{ index + 1
                    }}<i v-if="item.AddressType != 3">{{
                      item.AddressType == 1 ? "公司" : "家"
                    }}</i>
                  </h3>
                  <p>{{ item.FullAddress }}{{ item.HouseNumber }}</p>
                </div>
              </label>
            </div>
            <div class="icon-click">
              <button
                v-if="item.AddressType == 3"
                @click="DeleteAccountAddressFun(item)"
              >
                <svg
                  t="1598440402562"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="2856"
                  width="16"
                  height="16"
                >
                  <path
                    d="M517.59 21.609c-100.299 0-181.703 79.514-185.167 179.34H98.603c-25.979 0-47.235 21.099-47.235 47.236 0 25.98 21.099 47.237 47.236 47.237h52.117v528.416c0 99.196 67.233 180.285 150.37 180.285h423.55c82.98 0 150.37-80.616 150.37-180.285V295.737h47.236c25.98 0 47.236-21.1 47.236-47.237 0-25.98-21.099-47.236-47.236-47.236H702.441C699.449 101.124 617.888 21.61 517.59 21.61z m-96.677 179.34c3.464-51.172 45.19-90.85 96.834-90.85s93.37 39.835 96.362 90.85H420.913z m-119.98 714.842c-29.444 0-61.88-37.789-61.88-91.953V295.737h547.311V824.31c0 54.007-32.436 91.954-61.88 91.954H300.933v-0.473z m0 0"
                    p-id="2857"
                    fill="#333333"
                  ></path>
                  <path
                    d="M364.387 802.267c21.57 0 39.363-21.571 39.363-48.653V476.022c0-27.082-17.635-48.654-39.363-48.654-21.572 0-39.364 21.572-39.364 48.654v277.592c0 26.924 17.32 48.653 39.364 48.653z m142.496 0c21.571 0 39.363-21.571 39.363-48.653V476.022c0-27.082-17.635-48.654-39.363-48.654-21.571 0-39.364 21.572-39.364 48.654v277.592c0 26.924 17.793 48.653 39.364 48.653z m149.896 0c21.571 0 39.364-21.571 39.364-48.653V476.022c0-27.082-17.635-48.654-39.364-48.654-21.571 0-39.363 21.572-39.363 48.654v277.592c0 26.924 17.162 48.653 39.363 48.653z m0 0"
                    p-id="2858"
                    fill="#333333"
                  ></path>
                </svg>
              </button>
              <button @click="EditAddressFun(item)">
                <svg
                  t="1598422066894"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="3993"
                  width="16"
                  height="16"
                >
                  <path
                    d="M73.216 936.96h877.568v86.016H73.216zM281.6 881.664H73.216V670.72L739.328 0l211.456 207.872L281.6 881.664z m-126.464-81.92h92.672L835.072 208.896l-94.72-93.184-585.216 588.8v95.232z"
                    fill="#333333"
                    p-id="3994"
                  ></path>
                </svg>
              </button>
            </div>
          </li>
        </ul>
        <div class="bottom-fun-btn">
          <button class="yes-btn" @click="confirmAddressFun">确认</button>
          <button class="add-btn" @click="addAddressFun">新增</button>
        </div>
      </div>
    </my-dialog>
    <my-dialog
      :show="addAndEditAddressShow"
      :title="addAndEditAddressTitle"
      @close="addAndEditAddressShow = false"
    >
      <div class="cell-phone-wrap">
        <div class="phone-number-content">
          <label
            ><span><i style="color: red;">*</i>服务区域：</span></label
          >
          <div class="btn-input-content">
            <div>
              <input
                type="text"
                @click="openMap()"
                :value="form.FullAddress"
                placeholder="请选择服务区域"
              />
            </div>
          </div>
        </div>
        <div class="phone-number-content">
          <label
            ><span><i style="color: red;">*</i>详细地址：</span></label
          >
          <div class="btn-input-content">
            <div>
              <input
                type="text"
                v-model="form.HouseNumber"
                placeholder="请输入详细地址"
              />
            </div>
          </div>
        </div>
        <div class="bottom-fun-btn">
          <button class="yes-btn" @click="addAndEditAddressBtnFun">确认</button>
        </div>
      </div>
    </my-dialog>
    <my-dialog
      class="map-dialog"
      :show="showMap"
      title="地址"
      @close="showMap = false"
    >
      <iframe id="map" :src="mapUrl" frameborder="0" class="baidu-map"></iframe>
    </my-dialog>
  </div>
</template>
<script>
import navHeader from "@/components/navHeader.vue";
import {
  GetPickMarketJobPara, //获取投标参数
  PickMarketJob, //自由平台投标
  GetMarketJobTenderInfo, //获取自由平台投标信息
  UpdateMarketTenderInfo, //修改自由平台投标信息
  GetJobB2BAddressList, //获取地图列表
  DeleteAccountAddress, //删除地址
  AddAccountAddress,
  UpdateAccountAddress,
  UploadImg,
} from "@/scripts/api.js";
import { mapState } from "vuex";
import myDialog from "@/components/gkDialog.vue";
import { bpoConfirm, bpoAlert } from "@/scripts/bpo.js";
import Bus from "@/scripts/bus.js";
export default {
  data() {
    return {
      UploadImg,
      uesrCode: "",
      submitDisabled: false, //按钮是否禁止
      jobId: "", //工单id
      LoginType: "", //1=个人 2=企业
      uesrId: "", //个人登录id
      CompanyId: "", //企业登录id
      isTax: true, //是否含税价格
      TaxRate: 0, //预算是否含税
      info: {
        Title: "", //工单名称
        JobType: "", //工单类型1=自由平台 6=B2B专区 8=内部工单
        ProvinceName: "", //省名称
        CityName: "", //市名称
        JobLinkMan: "", //联系人
        JobNo: "", //单号
        JobHandSet: "", //联系电话
        ExecStartDate: "", //上门开始时间
        ExecEndDate: "", //上门结束时间
        ServiceDayCount: "", //服务天数
        MinPrice: 0,
        MaxPrice: 0,
      },
      addressInfo: {
        Lat: 0, //经度
        Lng: 0, //纬度
        JobDistance: "", //距离
        StartingAddress: "", //出发地址
        CityId: "", //市
        CityName: "", //市名称
        ProvinceId: "", //省
        ProvinceName: "", //省名称
      },
      form: {
        Id: "", //修改时用
        CityID: "",
        CityName: "",
        FullAddress: "",
        ProvinceID: "",
        ProvinceName: "",
        Lat: "",
        Lng: "",
        HouseNumber: "", //详细地址
      },
      AddressId: "", //出发地址id
      projectJobPriceDetail: {
        WorkLogDayCount: "", //预计服务天数
        WorkLogAmountTax: "", //服务报价（含税）
        TrafficAmountTax: "", //交通费用（含税）
        HousingAmountTax: "", //住宿费用（含税）
        TotalAmountTax: "", //总费用（含税）

        WorkLogAmount: "", //服务报价
        TrafficAmount: "", //交通费用
        HousingAmount: "", //住宿费用
        TotalAmount: "", //总费用

        content: "", //解决方案
      },
      DocFileList: [], //补充文档
      label: "确认投标",
      JobApplyOrderId: "",

      goAdderssShow: false, //出发地址框
      addressValue: null, //选中返回地址item
      addressValueId: 0, //地址id
      addAndEditAddressShow: false, //新增地址框
      addAndEditAddressTitle: "", //或 编辑地址

      addressList: [], //地址列表
      showMap: false, //地图
      addressEdit: null, //编辑地址的时候用
      isEdit: true, //是否编辑
    };
  },
  components: {
    navHeader,
    myDialog,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    //企业
    WorkLogAmountNoTaxRate() {
      //换算不含税价格->服务报价
      var num = (
        parseFloat(this.projectJobPriceDetail.WorkLogAmountTax || 0) /
        parseFloat(this.TaxRate)
      ).toFixed(2);
      return num == 0.0 ? "" : num;
    },
    TrafficAmountNoTaxRate() {
      //换算不含税价格->交通费用
      var num = (
        parseFloat(this.projectJobPriceDetail.TrafficAmountTax || 0) /
        parseFloat(this.TaxRate)
      ).toFixed(2);
      return num == 0.0 ? "" : num;
    },
    HousingAmountNoTaxRate() {
      //换算不含税价格->住宿费用
      var num = (
        parseFloat(this.projectJobPriceDetail.HousingAmountTax || 0) /
        parseFloat(this.TaxRate)
      ).toFixed(2);
      return num == 0.0 ? "" : num;
    },
    TotalAmountTaxRate() {
      //含税总价格 -> 企业
      return (
        parseFloat(this.projectJobPriceDetail.WorkLogAmountTax || 0) +
        parseFloat(this.projectJobPriceDetail.TrafficAmountTax || 0) +
        parseFloat(this.projectJobPriceDetail.HousingAmountTax || 0)
      ).toFixed(2);
    },
    TotalAmountNoTaxRate() {
      //不含税总价格 -> 企业
      return (
        parseFloat(this.WorkLogAmountNoTaxRate || 0) +
        parseFloat(this.TrafficAmountNoTaxRate || 0) +
        parseFloat(this.HousingAmountNoTaxRate || 0)
      ).toFixed(2);
    },
    //个人
    WorkLogAmountYesTaxRate() {
      var num = (
        parseFloat(this.projectJobPriceDetail.WorkLogAmount || 0) *
        parseFloat(this.TaxRate)
      ).toFixed(2);
      return num == 0.0 ? "" : num;
    },
    TrafficAmountYesTaxRate() {
      var num = (
        parseFloat(this.projectJobPriceDetail.TrafficAmount || 0) *
        parseFloat(this.TaxRate)
      ).toFixed(2);
      return num == 0.0 ? "" : num;
    },
    HousingAmountYesTaxRate() {
      //换算含税价格->住宿费用
      var num = (
        parseFloat(this.projectJobPriceDetail.HousingAmount || 0) *
        parseFloat(this.TaxRate)
      ).toFixed(2);
      return num == 0.0 ? "" : num;
    },
    TotalAmountTaxs() {
      //不含税总价格 -> 个人
      return (
        parseFloat(this.projectJobPriceDetail.WorkLogAmount || 0) +
        parseFloat(this.projectJobPriceDetail.TrafficAmount || 0) +
        parseFloat(this.projectJobPriceDetail.HousingAmount || 0)
      ).toFixed(2);
    },
    TotalAmountYesTaxRate() {
      //含税总价格 -> 个人
      return (
        parseFloat(this.WorkLogAmountYesTaxRate || 0) +
        parseFloat(this.TrafficAmountYesTaxRate || 0) +
        parseFloat(this.HousingAmountYesTaxRate || 0)
      ).toFixed(2);
    },
    mapUrl() {
      let url=`${location.protocol}//${location.host}${location.pathname}#/baiduMap?userType=${this.userInfo.LoginAccountType}&userId=${this.userInfo.LoginAccountId}`;
      return url;
    },
  },
  created() {
    console.log(this.$route.query)
    this.init();
    this.receiveData();
  },
  methods: {
    init() {
      let userInfo = this.userInfo;
      this.LoginType = userInfo.LoginAccountType;
      if (this.LoginType == 1) {
        this.uesrId = userInfo.LoginAccountId;
        this.CompanyId = "";
      } else {
        this.uesrId = "";
        this.CompanyId = userInfo.LoginAccountId;
      }
      this.uesrCode = userInfo.UserCode;
      this.jobId = this.$route.query.jobId;
      this.JobApplyOrderId = this.$route.query.JobApplyOrderId;
      if (!this.JobApplyOrderId) {
        this.getPickMarketJobPara(0);
      } else {
        this.label = "保存";
        this.lookServicePlanShow(this.JobApplyOrderId);
      }
    },
    //获取自由平台工单参数
    getPickMarketJobPara(addressid) {
      var data = {
        jobId: this.jobId || 0,
        AddressId: addressid,
        loginUserId: this.uesrId,
        loginCompanyId: this.CompanyId,
        platform: "pcweb",
      };
      !data.loginUserId && delete data.loginUserId;
      !data.loginCompanyId && delete data.loginCompanyId;
      GetPickMarketJobPara(data).then((r) => {
        if(r.Result==1){
          this.info = r.Data.JobVO;
          // this.info.MinPrice = r.Data.MinPrice
          // this.info.MaxPrice = r.Data.MaxPrice
          this.TaxRate = r.Data.TaxRate;
          this.addressInfo = r.Data.AddressVO;
        }else{
          this.$toast(r.Message);
        }
      });
    },
    //接受iframe传出来的信息
    receiveData() {
      let that = this;
      window.addEventListener("message", function(e) {
        let data = {};
        let value = e.data;
        if (that.isJsonString(value)) {
          data = JSON.parse(value);
        }
        if (that.showEditAddress) {
          Bus.$emit("confirmMap", data);
        } else {
          if (data.Lat) {
            that.addressEdit = {};
            for (const i in data) {
              that.form[i] = data[i];
              that.addressEdit[i] = data[i];
            }
          }
        }
        that.showMap = false;
      });
    },
    //点击切换含税/不含税
    clickSwitchTaxFun(boo) {
      this.isTax = boo;
    },
    // 上传补充文档
    supplementDocument(file, res) {
      if(file.Result==1){
        let arr=file.Data;
        var data = {
          FileExt: arr[0].fileExt,
          FileName: arr[0].fileName,
          IconUrl: arr[0].imgUrl,
        };
        this.DocFileList = this.DocFileList.concat(data);
        this.$nextTick(() => {
          this.$previewRefresh();
        });
      }else{
        this.$toast(file.Message);
      }
      
    },
    //删除补充文档
    removeEngineerDoc(idx) {
      this.DocFileList.splice(idx, 1);
    },
    // 确定投标/保存
    SubmitTenderAndSave() {
      if (!this.addressInfo.StartingAddress) {
        return this.$toast("请添加出发地址");
      }
      if (!this.projectJobPriceDetail.WorkLogDayCount) {
        return this.$toast("请填写预计服务天数");
      }
      if (
        (!this.projectJobPriceDetail.WorkLogAmountTax && this.LoginType == 2) ||
        (!this.projectJobPriceDetail.WorkLogAmount && this.LoginType == 1)
      ) {
        return this.$toast("请填写服务报价");
      }
      if (!this.projectJobPriceDetail.content) {
        return this.$toast("请填写解决方案");
      }
      let docFileList = [];
      if (this.DocFileList.length != 0) {
        for (let i in this.DocFileList) {
          docFileList.push(this.DocFileList[i].IconUrl);
        }
      }
      this.submitDisabled = true;
      var data = {
        jobId: this.jobId,
        loginUserId: this.uesrId,
        loginCompanyId: this.CompanyId,
        content: this.projectJobPriceDetail.content,
        fileUrlArray: docFileList,
        WorkLogDayCount: this.projectJobPriceDetail.WorkLogDayCount,
        platform: "pcweb",
      };
      data.WorkLogAmount =
        this.LoginType == 2
          ? this.projectJobPriceDetail.WorkLogAmountTax
          : this.projectJobPriceDetail.WorkLogAmount;
      data.TrafficAmount =
        this.LoginType == 2
          ? this.projectJobPriceDetail.TrafficAmountTax
          : this.projectJobPriceDetail.TrafficAmount;
      data.HousingAmount =
        this.LoginType == 2
          ? this.projectJobPriceDetail.HousingAmountTax
          : this.projectJobPriceDetail.HousingAmount;
      data = Object.assign(data, this.addressInfo);

      !data.loginUserId && delete data.loginUserId;
      !data.loginCompanyId && delete data.loginCompanyId;
      !data.TrafficAmount && delete data.TrafficAmount;
      !data.HousingAmount && delete data.HousingAmount;
      data.fileUrlArray == 0 && delete data.fileUrlArray;
      delete data.JobDistance;
      delete data.CityName;
      delete data.ProvinceName;
      if (!this.JobApplyOrderId) {
        PickMarketJob(data).then((res) => {
          this.submitDisabled = false;
          if (res.Result != 1 && res.Result != 611) {
            return bpoAlert(res.Message);
            // this.$toast(res.Message)
          }
          let that=this;
          if (res.Result == 611) {
            return bpoConfirm(res.Message, function() {
              that.$router.push('/center/serviceCertificate');
            });
          }
          this.$toast(res.Message);
          this.$router.push({
            path:'/orderDetail',
            query:{
              jobId:data.jobId,
            }
          })
        });
      } else {
        delete data.jobId;
        delete data.loginUserId;
        delete data.loginCompanyId;
        data.JobApplyOrderId = this.JobApplyOrderId;
        UpdateMarketTenderInfo(data).then((res) => {
          this.submitDisabled = false;
          this.$toast(res.Message);
          if (res.Result != 1) {
            return;
          }
          this.$touter.push({
            path:'/pickOrderInfo',
            query:{
              jobNo:this.info.JobNo
            }
          })
        });
      }
    },
    //获取服务方案
    lookServicePlanShow(id) {
      var data = {
        JobApplyOrderId: id,
        platform: "pcweb",
      };
      GetMarketJobTenderInfo(data).then((res) => {
        this.addressInfo = res.Data.AddressVO;
        this.info = res.Data.JobVO;
        this.info.MinPrice = res.Data.MinPrice;
        this.info.MaxPrice = res.Data.MaxPrice;
        this.TaxRate = res.Data.TaxRate;
        this.projectJobPriceDetail.WorkLogDayCount = res.Data.WorkLogDayCount;
        this.projectJobPriceDetail.WorkLogAmountTax = res.Data.WorkLogAmountTax;
        this.projectJobPriceDetail.TrafficAmountTax = res.Data.TrafficAmountTax;
        this.projectJobPriceDetail.HousingAmountTax = res.Data.HousingAmountTax;
        this.projectJobPriceDetail.TotalAmountTax = res.Data.TotalAmountTax;
        this.projectJobPriceDetail.content = res.Data.Solution;
        this.DocFileList = res.Data.FileList;
        this.$nextTick(() => {
          this.$previewRefresh();
        });
      });
    },
    //点击更换地址
    clickReplaceAddressFun() {
      this.addressValue = null;
      this.goAdderssShow = true;
      this.getAddressListFun();
    },
    //获取地址列表
    getAddressListFun() {
      var data = {
        UserCode: this.uesrCode,
        platform: "pcweb",
      };
      GetJobB2BAddressList(data).then((res) => {
        this.addressList = res.Data;
        this.addressValueId = this.AddressId;
      });
    },
    onRadioChange(item) {
      this.addressValue = item;
    },
    //确认选中的地址
    confirmAddressFun() {
      var self = this;
      if (!this.addressValue) {
        var addressValueArr = this.addressList.filter(function(item) {
          return item.Id == self.addressValueId;
        });
        this.addressValue = addressValueArr[0];
      } else {
        if (!this.addressValue.Lat || !this.addressValue.Lng) {
          this.$toast("您选择的地址为空，请新增或编辑地址后重新选择！");
          return;
        }
      }
      this.AddressId = this.addressValue.Id;
      this.goAdderssShow = false;
      this.getPickMarketJobPara(this.AddressId);
    },
    //删除地址
    DeleteAccountAddressFun(item) {
      var self = this;
      var data = {
        AccountAddressId: item.Id,
        platform: "pcweb",
      };
      bpoConfirm("是否删除地址", function() {
        DeleteAccountAddress(data).then((res) => {
          if (res.Result != 1) {
            self.$toast(res.Message);
            return;
          }
          self.$toast("删除成功");
          self.getAddressListFun();
        });
      });
    },
    //编辑地址
    EditAddressFun(item) {
      this.goAdderssShow = false;
      this.addAndEditAddressShow = true;
      this.addAndEditAddressTitle = "编辑地址";
      this.addressEdit = item;
      this.form = this.addressEdit;
      this.isEdit = true;
    },
    //打开地图
    openMap() {
      this.showMap = true;
      this.$nextTick(() => {
        if (this.addressEdit) {
          document
            .getElementById("map")
            .contentWindow.postMessage(JSON.stringify(this.addressEdit), "*");
        }
      });
    },
    isJsonString(str) {
      try {
        if (typeof JSON.parse(str) == "object") {
          return true;
        }
      } catch (e) {
        return false;
      }
      return false;
    },
    //新增地址
    addAddressFun() {
      (this.form = {
        Id: "", //修改时用
        CityID: "",
        CityName: "",
        FullAddress: "",
        ProvinceID: "",
        ProvinceName: "",
        Lat: "",
        Lng: "",
        HouseNumber: "", //详细地址
      }),
        (this.addressEdit = null);
      this.goAdderssShow = false;
      this.addAndEditAddressShow = true;
      this.addAndEditAddressTitle = "新增地址";
      this.isEdit = false;
    },
    //新增|编辑地址
    addAndEditAddressBtnFun() {
      if (!this.form.FullAddress) {
        this.$toast("请选择服务区域");
        return;
      }
      if (!this.form.HouseNumber) {
        this.$toast("请输入详细地址");
        return;
      }
      var data = {
        UserCode: this.uesrCode,
        Lat: this.form.Lat,
        Lng: this.form.Lng,
        FullAddress: this.form.FullAddress,
        HouseNumber: this.form.HouseNumber,
        // ProvinceID: this.form.ProvinceID || 0,
        // CityID: this.form.CityID || 0,
        ProvinceID: 0,
        CityID: 0,
        CityName: this.form.CityName,
        platform: "pcweb",
      };
      if (this.isEdit) {
        data.Id = this.form.Id;
        UpdateAccountAddress(data).then((res) => {
          if (res.Result != 1) {
            this.$toast(res.Message);
            return;
          }
          this.$toast("编辑成功");
          this.addAndEditAddressShow = false;
          this.goAdderssShow = true;
          this.getAddressListFun();
        });
      } else {
        AddAccountAddress(data).then((res) => {
          if (res.Result != 1) {
            this.$toast(res.Message);
            return;
          }
          this.$toast("新增成功");
          this.addAndEditAddressShow = false;
          this.goAdderssShow = true;
          this.getAddressListFun();
        });
      }
    },
  },
};
</script>
<style lang="scss">
#app {
  background: #f9f9f9;
}
.det-body {
  padding-top: 68px;
  .container {
    width: 840px;
    margin: 0 auto;
    overflow: hidden;
  }
  .address-text {
    line-height: 20px;
    font-size: 14px;
    padding-left: 24px;
    color: #333333;
    background-image: url('~@/assets/address-icon.png');
    background-repeat: no-repeat;
    background-position: left center;
    padding-bottom: 0;
    word-break: break-all;
  }
  .tender-info-top {
    margin: 20px 0;
    padding: 0 20px;
    background: #ffffff;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    min-height: 240px;
    overflow: hidden;
    .basic-info-title {
      .order-title {
        font-size: 30px;
        font-family: "Source Han Sans CN";
        font-weight: bold;
        color: #333333;
        margin: 20px 0;
        padding-right: 88px;
        position: relative;
        line-height: 40px;
        span {
          display: inline-block;
          vertical-align: middle;
          color: #ffffff;
          background: #f75959;
          font-size: 12px;
          line-height: 20px;
          width: 68px;
          text-align: center;
          font-weight: normal;
          position: absolute;
          right: 0;
          top: 10px;
          border-radius: 2px;
        }
      }
    }
    .basic-info-label {
      margin-top: 6px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      li {
        display: flex;
        align-items: center;
        width: 50%;
        font-size: 14px;
        height: 34px;
        color: #666666;
        font-weight: 400;
        label {
          width: 120px;
        }
      }
    }
  }
  .tender-set-content {
    margin-bottom: 40px;
    background: #ffffff;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    min-height: 920px;
    padding: 0 20px;
    .h3-title {
      padding: 25px 0;
      text-align: center;
      font-size: 20px;
      font-family: "Source Han Sans CN";
      font-weight: bold;
      color: #333333;
    }
    .subtitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      h2 {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-family: "Source Han Sans CN";
        font-weight: bold;
        color: #333333;
        i {
          color: red;
          font-size: 18px;
          padding-left: 7px;
          margin-top: 4px;
        }
      }
      button {
        background: none;
        padding: none;
        font-size: 13px;
        font-family: "Source Han Sans CN";
        font-weight: 400;
        color: #f75959;
        line-height: 12px;
        cursor: pointer;
      }
      button:hover {
        text-decoration: underline;
      }
    }
    .km {
      margin: 12px 0 22px 24px;
      display: inline-block;
      vertical-align: top;
      height: 24px;
      background: #e5e5e5;
      border-radius: 4px;
      font-size: 14px;
      font-family: "Source Han Sans CN";
      font-weight: 500;
      color: #333333;
      line-height: 24px;
      padding: 0 8px;
    }
    .gery-bg {
      height: 10px;
      font-size: 0;
      background: #f9f9f9;
      margin-bottom: 16px;
    }
    .bid-cost-detail {
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        border-bottom: 1px solid #e5e5e5;
        label {
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          padding-left: 10px;
          i {
            color: red;
            font-size: 12px;
          }
        }
        input {
          height: 38px;
          width: 80%;
          text-align: right;
          font-size: 14px;
          color: #333333;
          font-weight: 500;
          padding-right: 10px;
        }
        p.sum {
          color: red;
          font-weight: bold;
          font-size: 14px;
          padding-right: 10px;
        }
      }
      li:last-child {
        border: none;
      }
    }
    .tips {
      text-align: right;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      margin-bottom: 20px;
      margin-top: 10px;
    }
    .bid-cost-switch {
      display: flex;
      align-items: center;
      color: #999999;
      span {
        cursor: pointer;
        font-size: 12px;
        font-family: "Source Han Sans CN";
        font-weight: 400;
        color: #666;
      }
      .on-tab {
        color: rgba(247, 89, 89, 1);
      }
      span:hover {
        text-decoration: underline;
      }
    }
    .textarea {
      display: block;
      width: 100%;
      height: 100px;
      border: 1px solid #e3e3e3;
      padding: 5px 10px;
      font-size: 14px;
      color: #333;
      line-height: 22px;
      resize: none;
      border-radius: 4px;
      background: #f9f9f9;
      margin-bottom: 20px;
      &:read-only {
        cursor: not-allowed;
        background-color: #f5f5f5;
      }
      &:focus {
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
      }
    }
  }
}
.itmes-content {
  min-height: 100px;
  > .upload-div {
    display: inline-block;
    vertical-align: top;
    margin-bottom: 20px;
    height: 80px;
    width: 80px;
    .icon-file {
      display: inline-block;
      position: relative;
      width: 80px;
      height: 80px;
      border: 1px solid #e3e3e3;
      cursor: pointer;
    }
    .icon-file:before,
    .icon-file:after {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      background-color: #e3e3e3;
    }
    .icon-file:before {
      width: 40px;
      height: 2px;
      margin-left: -20px;
      margin-top: -1px;
    }

    .icon-file:after {
      width: 2px;
      height: 40px;
      margin-top: -20px;
      margin-left: -1px;
    }
  }
  > span {
    display: inline-block;
    vertical-align: top;
    width: 80px;
    height: 80px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #e5e5e5;
    margin-right: 20px;
    margin-bottom: 20px;
    transition: all 0.2s ease-in-out;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    a {
      display: block;
      width: 100%;
      height: 100%;
    }
    img {
      display: block;
      height: auto;
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      max-width: 100%;
    }
    .name-hover-show {
      display: block;
      position: absolute;
      bottom: -26px;
      left: 0;
      height: 24px;
      background: rgba(0, 0, 0, 0.6);
      text-align: center;
      line-height: 24px;
      font-size: 12px;
      color: #fff;
      width: 100%;
      z-index: 2;
      -webkit-transition: all 0.1s linear;
      transition: all 0.1s linear;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .delete-this-dom {
      position: absolute;
      right: -1px;
      top: -1px;
      width: 18px;
      height: 18px;
      z-index: 2;
      opacity: 0;
      transition: all 0.2s ease-in-out;
      -webkit-transition: all 0.2s ease-in-out;
      -moz-transition: all 0.2s ease-in-out;
      -o-transition: all 0.2s ease-in-out;
      border: 1px solid #e5e5e5;
      line-height: 18px;
      text-align: center;
      background: #fff;
      &:hover {
        background: rgba(0, 0, 0, 0.2);
      }
    }
    &:hover {
      .delete-this-dom {
        opacity: 1;
      }
      .name-hover-show {
        bottom: 0px;
      }
    }
  }
}
.submit-tender {
  display: inline-block;
  vertical-align: top;
  width: 120px;
  height: 38px;
  background: #f75959;
  border-radius: 2px;
  text-align: center;
  font-size: 16px;
  font-family: "Source Han Sans CN";
  line-height: 36px;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
  margin: 30px auto 50px;
  cursor: pointer;
}
input[disabled],
.disabled li {
  background: #f9f9f9;
}
input[disabled]:hover {
  cursor: no-drop;
}

.address-list-div {
  padding: 0 30px;
  .address-box-ul {
    max-height: 400px;
    overflow: auto;
    .address-items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 68px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      position: relative;
      .radio {
        opacity: 0;
        position: absolute;
        left: 0;
        right: 0;
      }
      label {
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        div {
          padding-left: 30px;
        }
      }
      label::before {
        content: "";
        cursor: pointer;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: 50%;
        border: 1px solid #ddd;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        background-color: #fff;
        padding: 2px;
      }
      button {
        background: none;
        padding: 0;
        cursor: pointer;
      }
      .radio:checked + label::before {
        background-color: #f75959;
        border-color: #f75959;
        background-clip: content-box;
      }
    }
  }
}
.address-info-content {
  h3 {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: "Source Han Sans CN";
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
    i {
      width: 38px;
      height: 14px;
      background: rgba(255, 56, 56, 1);
      border-radius: 4px;
      margin-left: 15px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      line-height: 14px;
      font-weight: normal;
    }
  }
  p {
    font-size: 14px;
    font-family: "Source Han Sans CN";
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 26px;
  }
}
.bottom-fun-btn {
  display: flex;
  justify-content: center;
  align-content: center;
  margin-top: 30px;
  margin-bottom: 10px;
  button {
    cursor: pointer;
  }
  .yes-btn {
    width: 100px;
    height: 30px;
    background: rgba(247, 89, 89, 1);
    border-radius: 2px;
    font-size: 14px;
    font-family: "Hiragino Sans GB";
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
    line-height: 28px;
    padding: none;
    border: none;
    margin-right: 15px;
    border-radius: 2px;
  }
  .add-btn {
    margin-left: 15px;
    font-size: 14px;
    font-family: "Source Han Sans CN";
    font-weight: 400;
    color: rgba(247, 89, 89, 1);
    padding: 0;
    background: none;
  }
  .add-btn:hover {
    text-decoration: underline;
  }
}
.baidu-map {
  width: 100%;
  height: 500px;
}
.icon-click {
  display: inline-flex;
  justify-content: center;
  button {
    display: inline-flex;
    align-items: center;
    margin: 0 10px;
  }
}
.cell-phone-wrap {
  padding: 0 20px;
  .phone-number-content {
    padding-left: 100px;
    position: relative;
    min-height: 40px;
    margin-top: 30px;
    margin-bottom: 30px;
    label {
      position: absolute;
      left: 0;
      top: 0;
      line-height: 40px;
      color: #333;
      font-size: 16px;
    }
    .btn-input-content {
      border: 1px solid #e5e5e5;
      height: 40px;
      margin-right: 30px;
      position: relative;
      input {
        display: block;
        height: 38px;
        border: none;
        padding: 0 7px;
        padding-right: 40px;
        color: #333;
        font-size: 16px;
        width: 100%;
      }
      button {
        position: absolute;
        right: -1px;
        top: -1px;
        height: 40px;
        border: none;
        background: #f75959;
        color: #fff;
        font-size: 14px;
        width: 100px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        &:hover {
          background: #ff3838;
        }
      }
    }
  }
  p {
    font-size: 14px;
    line-height: 24px;
    color: #999;
    padding: 5px 0;
    i {
      color: #f75959;
    }
  }
}
</style>
